function initProfileThumbs(icon)
{
    $.each($('.profiles-list .subs-action'), function(i, element)
    {
        if(!$.cookie('user-logged') || $.cookie('user-logged') == -1)
        {
            setUnsuscribedProfile($(element), icon);
        }
        else
        {
            if($(element).hasClass('remove'))
            {
                setSuscribedProfile($(element), icon);
            }

            if($(element).hasClass('add'))
            {
                setUnsuscribedProfile($(element), icon);
            }
        }

        setControlFunctionality(element, icon);
    });
}

function setControlFunctionality(element, icon)
{
    $(element).on('click', function()
    {
        if($.cookie('user-logged') && $.cookie('user-logged') != -1)
        {
            if($(this).hasClass('remove'))
            {
                setUnsuscribedProfile($(this), icon);
            }
            else
            {
                setSuscribedProfile($(this), icon);
            }
        }
    })
}

function setSuscribedProfile(element, icon)
{
    element.removeClass('btn-subscribe-thumb').addClass('btn-subscribed-thumb');

    if(icon)
    {
        element.after($('<span></span>').addClass('icon-ok-circled subscribed-ok'));
    }
}

function setUnsuscribedProfile(element, icon)
{
    element.removeClass('btn-subscribed-thumb').addClass('btn-subscribe-thumb');

    if(icon)
    {
        element.parent().find('.subscribed-ok').remove();
    }
}
